import { defineComponent as n, computed as o, createBlock as i, createCommentVNode as s, openBlock as a, unref as c, withCtx as u, createTextVNode as f, toDisplayString as m } from "vue";
import d from "../../../../components/Badge/Badge.vue.js";
const x = /* @__PURE__ */ n({
  __name: "InfoVersion",
  props: {
    version: {}
  },
  setup(t) {
    const r = o(() => {
      if (t.version == null)
        return t.version;
      const e = String(t.version);
      return /^\d/.test(e) ? `v${e}` : e;
    });
    return (e, l) => r.value ? (a(), i(c(d), { key: 0 }, {
      default: u(() => [
        f(m(r.value), 1)
      ]),
      _: 1
    })) : s("", !0);
  }
});
export {
  x as default
};
